import { AgentKnowledgeStatus } from "@redotech/crdb-enums/agent-knowledge/agent-knowledge-status";
import { productKnowledgeSortSchema } from "@redotech/shopper-agent-knowledge-common/knowledge-sort";
import { productKnowledgeListItemSchema } from "@redotech/shopper-agent-knowledge-common/product-knowledge-view";
import * as z from "zod";

/**
 * Product specific knowledge, newest first. Separate from `listKnowledge`: this
 * corpus has no registry entry, so it cannot appear in that union.
 */
export const listProductKnowledge = {
  name: "listProductKnowledge" as const,
  input: z.object({
    /** Matches linked product titles, never the content. */
    query: z.string().optional(),
    statuses: z.array(z.enum(AgentKnowledgeStatus)).optional(),
    /** Newest first when absent. */
    sort: productKnowledgeSortSchema.optional(),
    limit: z.number().int().positive().optional(),
    offset: z.number().int().nonnegative().optional(),
  }),
  output: z.object({
    items: z.array(productKnowledgeListItemSchema),
    /** Items matching the query and filters, for the pager. */
    totalItemCount: z.number(),
  }),
};
